import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Typography,
  Button,
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import InfiniteScroll from 'react-infinite-scroll-component'
import { usePurchasing } from '../../purchasing'
import InventoryLocationCard from './InventoryLocationCard'
import { fetchLocations, createLocation } from '../slice'

const useStyles = makeStyles(theme => ({
  countLabel: {
    display: 'none',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('tablet')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
}))

const InventoryLocationList = ({ hasNextPage, onFetchMore }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { purchasingEnvironment } = usePurchasing()

  const [isModalOpen, setModalOpen] = useState(false)
  const [locationName, setLocationName] = useState('') // State for the location name

  const locations = useSelector(state => state.buyer.inventory.locations)
  const isLoading = useSelector(state => state.buyer.inventory.isLoading)

  useEffect(() => {
    dispatch(fetchLocations(purchasingEnvironment))
  }, [dispatch, purchasingEnvironment])

  const total = locations.length
  const showingText = `Showing ${total} ${
    total === 1 ? 'location' : 'locations'
  }`

  const handleAddLocation = async () => {
    await dispatch(
      createLocation({
        environmentId: purchasingEnvironment,
        body: {
          name: locationName, // Use the location name from state
        },
      })
    )
    dispatch(fetchLocations(purchasingEnvironment))
    setModalOpen(false)
  }

  return (
    <div>
      <div className={classes.countLabel}>
        <Typography variant="body2" color="textSecondary">
          {showingText}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setModalOpen(true)}
        >
          Add Location
        </Button>
      </div>

      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>Add Location</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            variant="outlined"
            label="Location Name"
            value={locationName}
            onChange={e => setLocationName(e.target.value)} // Update state when text changes
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAddLocation} color="primary">
            Add Location
          </Button>
        </DialogActions>
      </Dialog>

      {!isLoading ? (
        <>
          <InfiniteScroll
            dataLength={locations.length}
            next={onFetchMore}
            hasMore={hasNextPage}
          >
            {locations.map(location => (
              <>
                <InventoryLocationCard location={location} />
                <div style={{ height: 20 }} />
              </>
            ))}
          </InfiniteScroll>
        </>
      ) : (
        [1, 2, 3].map(() => (
          <Skeleton
            variant="rect"
            height={150}
            style={{
              borderRadius: 10,
              marginTop: 10,
              marginBottom: 9,
            }}
          />
        ))
      )}
    </div>
  )
}

InventoryLocationList.defaultProps = {
  hasNextPage: false,
  suppliers: [],
  total: 0,
}

export default InventoryLocationList
